export default __webpack_public_path__ + "static/media/title_case1.07c821bb.jpg";